export default __webpack_public_path__ + "static/media/603.5d524d7c.png";